import { render, staticRenderFns } from "./BlackGoldAttendancePage.vue?vue&type=template&id=c35d0a6a&scoped=true"
import script from "./BlackGoldAttendancePage.vue?vue&type=script&lang=js"
export * from "./BlackGoldAttendancePage.vue?vue&type=script&lang=js"
import style0 from "./BlackGoldAttendancePage.vue?vue&type=style&index=0&id=c35d0a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35d0a6a",
  null
  
)

export default component.exports